import type { ProductDetail } from "@viajero/proto/guest/v1";

// 店舗 (Manager > TableCheck 店舗情報管理) の回転設定。on のとき shopTurnStartTimes
// ("HH:MM"、昇順) の時刻のみ予約でき、off のとき時刻は自由入力 (30 分刻み) になる。
type TurnSettings = Pick<ProductDetail, "shopTurnEnabled" | "shopTurnStartTimes">;

// 回転 on なら時間セレクトに並べる開始時間、off なら null (既存の TimePicker で自由入力)。
export function resolveTurnStartTimes(product: TurnSettings): string[] | null {
  return product.shopTurnEnabled ? product.shopTurnStartTimes : null;
}

// 指定した時刻 ("HH:MM") がこの店舗で予約可能かどうか。未入力は不可。
// 回転 on のときは開始時間に一致する時刻のみ可 (バックエンドの空席確認・決済の短絡と同じ判定)。
export function isSelectableTime(product: TurnSettings, time: string): boolean {
  if (!time) return false;
  const startTimes = resolveTurnStartTimes(product);
  return startTimes === null || startTimes.includes(time);
}
